<template lang="html">
  <div class="cases">
    <label class="labelTitle blue">{{titleToUpperCase($t('cases.title'))}}</label>
    <p class="description blue" v-html="$t('cases.description')"></p>
    <ul class="caseItems">
      <li v-for="(item,key) in $t('cases.caseList')" :key="key">
        <!-- <span class="img" :style="{'background': 'url('+ item.imgUrl +')','backgroundSize': 'cover'}"></span> -->
        <div class="avatar">
          <img :src="item.imgUrl" alt="">
          <span class="title blue">{{item.title}}</span>
        </div>
        <span class="desc" v-html="item.description"> </span>
      </li>
    </ul>
  </div>

</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.cases {
  padding: 5rem 2rem;
  display: flex;
  flex-flow: column;
  .labelTitle {
    padding: 0;
    margin: 0;
    // dispaly: inline-block;
  }
  .caseItems {
    // width:80%;
    display: flex;
    // flex-flow: row;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 auto;
    text-align: center;
    li {
      // margin: 1.25rem;
      display: flex;
      flex-flow: column;
      text-align: left;
      width: 22rem;
      float: left;
      // flex: 1;
      margin: .9rem;
      &:nth-children(4) {
        margin-right: 0;
      }
      // max-width: 25%;
     .avatar{
       position: relative;
       transition: all .8s;
       overflow: hidden;
       &:hover {
         transform: scale(1.05);
         z-index: 800;
       }
       img {
         object-fit: cover;
         width: 100%;
         height: 14rem;

       }
       .title {
         position: absolute;
         bottom: 0;
         left: 0;
         z-index: 500;
         font-size: 1.35rem;
         font-weight: 700;
         // margin: .5rem 0;
         width: 100%;
         background: rgba(0,0,0,.63);
         color: #ffffff;
         padding: .5rem .15rem;
       }
      }

      .desc {
        margin-top: .9rem;
        line-height: 1.5rem;
        /* font-size: 1.06rem; */
        color: #333;
        word-break: normal;
      }
    }
  }
}
</style>
